import { MessageEventType } from '../../../../shared/modules/trip/types/trip';
import { SortDirection } from '../../../../shared/utils/constants';
import {
  DateFilterLabelState,
  EndHourState,
  EndState,
  ExcludeWeekendsState,
  StartHourState,
  StartState,
  TransportReport,
  TransportsState,
} from '../../../types';

export interface FormattedTransportConditionalEventsReportItemDTO
  extends TransportConditionalEventsReportItemDTO {
  id: string;
  transportId: number;
  transportName: string;
  licensePlate: string;
  durationFormmated: string | null;
  dateFormatted: string;
  startEndTimeFormatted: string;
}

export type TransportConditionalEventsReportItemDTO = {
  eventType: string;
  duration: number;
  maxSpeed: number | null;
  start: string;
  end: string;
};

type TransportConditionalEventsReportDTO = {
  items: TransportConditionalEventsReportItemDTO[];
  licensePlate: string;
  name: string;
};

export type ConditionalEventsReportDTO =
  TransportReport<TransportConditionalEventsReportDTO>;

export type ConditionalEventsReportSlice = {
  isLoading: boolean;
  isFailed: boolean;
  transports: Record<
    number,
    FormattedTransportConditionalEventsReportItemDTO[]
  >;
};

export type EventTypeState = ConditionalEventType | null;
export type EventTypeFiltersState = EventTypeFilters;

export type ConditionalEventsFiltersState = {
  transports: TransportsState;
  start: StartState;
  end: EndState;
  startHour: StartHourState;
  endHour: EndHourState;
  excludeWeekends: ExcludeWeekendsState;
  dateFilterLabel: DateFilterLabelState;
  eventType: EventTypeState;
  eventTypeFilters: EventTypeFiltersState;
};

export type EventTypeFilters = {
  moreThanValue?: number;
  lessThanValue?: number;
  duration: number;
  resolve: number;
};

export type ConditionalEventsFilters = {
  transports: TransportsState;
  eventType: EventTypeState;
  start: string;
  end: string;
  tz: string;
} & EventTypeFilters;

export type ConditionalEventsSortParam = {
  sortBy: keyof FormattedTransportConditionalEventsReportItemDTO;
  sortDirection: SortDirection;
};

export type ConditionalEventsSortFilterConfig = {
  defaultSortBy: ConditionalEventsSortParam['sortBy'];
  defaultSortDirection: SortDirection;
};

export enum ConditionalEventType {
  STOP_TIME = MessageEventType.STOP_TIME,
  OVER_SPEEDING = MessageEventType.OVER_SPEEDING,
  TEMPERATURE = MessageEventType.TEMPERATURE,
  RPM_LIMIT = MessageEventType.RPM_LIMIT,
}
